import React, { useState, useEffect, useRef } from 'react';
import { InputIcon } from 'primereact/inputicon';
import { Tag } from 'primereact/tag';


export default function TagStatusEquipamento(props){

    if(props.equipamentoNovo === 't'){
        return <Tag className="ml-2 mt-2 " icon="pi pi-times-circle text-2xl" severity="info" value="Não monitorada"></Tag>
    }
    if(props.ativo == 'f'){
        return <Tag className="ml-2 mt-2  w-full" icon="pi pi-exclamation-triangle " severity="danger" value="INATIVO"></Tag>
    }

    if(!props.dias){
        return <Tag className="ml-2 mt-2  w-full" icon="pi pi-exclamation-triangle " severity="danger" value="OFFLINE"></Tag>
    }


    switch(props.status){
        case 1: // desconhecido
            return<Tag className="ml-2 mt-2  w-full " icon="pi pi-times-circle text-2xl" severity="info" value="Desconhecido"></Tag>
        break;
        case 2: // pronto
            return <Tag className="ml-2 mt-2  w-full" icon="pi pi-check-circle " severity="success" value="Pronto"></Tag>
        break;
        case 3: // energy saving
            return <Tag className="ml-2 mt-2  w-full" icon="pi pi-power-off " severity="warning" value="Energy Saving"></Tag>
        break;
        case 4: // imprimindo
            return <Tag className="ml-2 mt-2  w-full" icon="pi pi-print " severity="contrast" value="imprimindo"></Tag>
        break;
        case 5: // ocorrencia
            return <Tag className="ml-2 mt-2  w-full" icon="pi pi-wrench " severity="danger" value="Ocorrência"></Tag>
        break;
        case 6: // atenção
            return <Tag className="ml-2 mt-2  w-full" icon="pi pi-exclamation-triangle " severity="warning" value="Atenção"></Tag>
        break;
        case 7: // atolamento
            return <Tag className="ml-2 mt-2  w-full" icon="pi pi-wave-pulse " severity="danger" value="Atolamento"></Tag>
        break;
        case 8: // porta aberta
            return <Tag className="ml-2 mt-2  w-full" icon="pi pi-sign-out " severity="warning" value="Porta Aberta"></Tag>
        break;
        default: // desconhecido
            return <Tag className="ml-2 mt-2  w-full" icon="pi pi-question-circle " severity="info" value="Desconhecido"></Tag>
        break
    }
    
}